export function handleEvolutivoStrategy(plotData, viewConfigData) {
  if (!viewConfigData.graficos.length || !viewConfigData.graficos[0].checked) {
    return null;
  }
  const evolutivoConfig = viewConfigData.graficos[0].configuracoes.find(
    (evol) =>
      plotData.data.id_configuracao === evol.id_configuracao && evol.checked
  );

  const resultado = evolutivoConfig ? { ...plotData.data } : null;

  if (resultado) {
    const newData = {
      ...plotData,
      renderType: viewConfigData.graficos[0].render,
      data: resultado,
    };
    return newData;
  }
  return null;
}
